import React, { useState, useEffect } from "react";
import { SectionWrapper } from "../hoc";
import { technologies } from "../constants";
import BallCanvas from "./canvas/Ball";

// Mobile 2D grid component
const MobileTechGrid = () => (
  <div className="w-full py-8 bg-gradient-to-br from-gray-900 via-black to-gray-900">
    <h2 className='text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px] text-center mb-8'>
      Tech Stack
    </h2>
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-4 px-4">
      {technologies.map((tech) => (
        <div 
          key={tech.name} 
          className="flex flex-col items-center p-3 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors"
        >
          <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center">
            <img 
              src={tech.icon} 
              alt={tech.name}
              className="w-full h-full object-contain"
            />
          </div>
          <span className="text-white text-xs mt-2 text-center">
            {tech.name}
          </span>
        </div>
      ))}
    </div>
  </div>
);

const Tech = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024); // Show 2D grid on mobile and tablets
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Show 2D grid on mobile/tablet, 3D balls on desktop
  if (isMobile) {
    return <MobileTechGrid />;
  }

  return (
    <div className='w-full'>
      <h2 className='text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px] text-center mb-8'>
        Tech Stack
      </h2>
      <div className='flex flex-row flex-wrap justify-center gap-6 lg:gap-10'>
        {technologies.map((technology) => (
          <div className='w-20 h-20 lg:w-28 lg:h-28' key={technology.name}>
            <BallCanvas icon={technology.icon} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionWrapper(Tech, "");
